/* ActivityViewRenderer.js */

"use strict";

const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const BaseActivityViewRender = require("../../../../lib/activity/BaseActivityViewRender");

class ActivityViewRenderer extends BaseActivityViewRender {
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        return this._model.whenModelIsReady().then(() => {
            this._activityGrid = new EntityGrid({
                gridKey: this._model._gridKey,
                columns: this._model.columnConfig,
                pagingFeed: this._model._activityFeed,
                showHeader: true,
                columnOrder: ["activityType", "snapshot", "description", "status", "actions"]
            });

            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._activityGrid.renderer.rootElement);
            }
            this._registerListeners();
            this._renderGridRows();
            this._hideDownloadViewAction();
        });
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _showDownloadViewAction() {
        this._model.gameEditor.showViewAction("download");
    }

    _hideDownloadViewAction() {
        this._model.gameEditor.hideViewAction("download");
    }

    _showViewActions() {
        this._model.gameEditor.showViewAction("download");
        //this._model.gameEditor.showViewAction('addNote');
    }

    _hideViewActions() {
        this._model.gameEditor.hideViewAction("download");
        //this._model.gameEditor.hideViewAction('addNote');
    }

    _disableViewActions() {
        this._model.gameEditor.disableViewAction("download");
        //this._model.gameEditor.disableViewAction('addNote');
    }

    _enableViewActions() {
        this._model.gameEditor.enableViewAction("download");
        //this._model.gameEditor.enableViewAction('addNote');
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ActivityViewRenderer;
